import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { Styles } from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layout/components/AppCard";
import { useTranslation } from "react-i18next";
import MakeShop from "../../manage/shops/MakeShop";
import { connect } from "trim-redux";
import ShopHours from "../../manage/shops/components/ShopHours";
import ShopCategoryChooser from "../../manage/shops/components/ShopCategoryChooser";
import ShopMenus from "../../manage/shops/menus/ShopMenus";
import Title from "../../../components/elements/Title";
import { useNavigate, useLocation } from "react-router-dom";
import { IconButton, Tab, Tabs, Typography, useMediaQuery } from "@mui/material";
import { theme } from "../../../../config/design/theme";
import {CalendarClock, Grid2x2Check, MapPinned, Pen, ScrollText} from "lucide-react";
import ShopAddress from "../../manage/shops/components/ShopAddress";
import {fromApp} from "../../../../config/values";

function MyShopDetails({ user , isApp}) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Determine tab value based on URL path
    const tabValue = location.pathname.split('/').pop();

    const handleTabChange = (event, newValue) => {
        navigate(`/panel/vendor/setting/${newValue}`);
    };

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('shopDetails')}>
            <Grid container spacing={2} justify="center" className="shop-tabs">
                {(!!user.shop && !fromApp()) && (
                    <Grid item size={12}>
                        <Tabs
                            style={{ marginBottom: 20 }}
                            value={tabValue}
                            onChange={handleTabChange}
                            textColor="primary"
                            variant={isMobile ? 'scrollable' : ""}
                            scrollButtons={isMobile ? 'auto' : ""}
                            aria-label="Tab"
                            centered={!isMobile}
                            className="tabs-v-container"
                        >
                            <Tab value="details" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <Pen className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('editInfo')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="address" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <MapPinned className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('address')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="categories" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <Grid2x2Check className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('categories')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="menus" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <ScrollText className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('menus')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="hours" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <CalendarClock className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('shopHours')}</Typography>
                                     </div>
                                 }
                            />
                        </Tabs>
                    </Grid>
                )}
                {tabValue === "details" && (
                    <Grid item size={12}>
                        {
                            !isApp &&
                            <Title align="left" color="text" className='panel-title'>{t('shopDetails')}</Title>
                        }
                        <MakeShop create={!user.shop} />
                    </Grid>
                )}
                {
                    (user.shop &&  tabValue === "address") &&
                    <Grid item size={12}>
                        <ShopAddress />
                    </Grid>
                }
                {(user.shop && tabValue === "categories") && (
                    <Grid item size={12}>
                        <ShopCategoryChooser />
                    </Grid>
                )}
                {(user.shop && tabValue === "menus") && (
                    <Grid item size={12}>
                        <ShopMenus />
                    </Grid>
                )}
                {(user.shop && tabValue === "hours") && (
                    <Grid item size={12}>
                        <ShopHours />
                    </Grid>
                )}
            </Grid>
        </AppAnimate>
    );
}

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    isApp: state.isApp,

});

export default withStyles(Styles)(connect(mstp)(MyShopDetails));
